/* eslint camelcase: 0 */
import { toFileProps } from './file'
import { ScheduledTalk, ScheduledTalkRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IScheduledTalkProps, EmptyScheduledTalkPropsFactory } from '@/entities/ScheduledTalk'

export const toScheduledTalkProps = (props: ScheduledTalk | null | undefined): IScheduledTalkProps => {
  if (!props) {
    return EmptyScheduledTalkPropsFactory()
  }

  const { id, room_id, talker, talker_id, talker_type, message, files, scheduled_at, sent_at, room, created_at, updated_at } = props

  return EmptyScheduledTalkPropsFactory({
    id,
    roomId: room_id,
    talker,
    talkerId: talker_id,
    talkerType: talker_type,
    message,
    files,
    // 共通のtoFileProps()はmedia_id（サーバー側の添付ファイルID）を引き継がないため、
    // 個別削除に必要なidをここで別途補う（file.tsは他機能と共有のため変更しない）
    keeps: files?.map((file) => ({ ...toFileProps(file), id: file.media_id })),
    scheduledAt: scheduled_at,
    sentAt: sent_at,
    room,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toScheduledTalkRequest = (props: IScheduledTalkProps): ScheduledTalkRequest => {
  const { message, keeps, data, scheduledAt } = props
  return {
    message,
    keeps: JSON.stringify(keeps),
    files: data!,
    scheduled_at: scheduledAt!
  }
}
